module.exports = __webpack_public_path__ + "media/images/bnr-line-bb2b27de1ef0f31bbb702a21d0b940ce.svg";